import { Heading, Icon } from '@assembly-js/design-system';
import clsx from 'clsx';
import React from 'react';

interface PageTitleMenuButtonProps {
  title: string;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
}

export const PageTitleMenuButton = React.forwardRef<
  HTMLSpanElement,
  PageTitleMenuButtonProps
>(({ title, onClick, className }, ref) => (
  <button
    type="button"
    onClick={onClick}
    className={clsx(
      'flex items-center gap-1 p-1 rounded bg-transparent border-0 cursor-pointer hover:bg-primary-hover truncate',
      className,
    )}
  >
    <span ref={ref}>
      <Heading size="sm" className="truncate">
        {title}
      </Heading>
    </span>
    <Icon icon="ChevronDown" className="w-3 h-3 shrink-0" />
  </button>
));
PageTitleMenuButton.displayName = 'PageTitleMenuButton';
